import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { loadAiPanel, LOCALIZATION_SCOPE } from '@capital-access/ai-panel/common';

@Component({
  selector: 'ca-ai-chat-button',
  templateUrl: './ai-chat-button.component.html',
  styleUrls: ['./ai-chat-button.component.scss']
})
export class AiChatButtonComponent {
  L10N = LOCALIZATION_SCOPE;

  openDrawer() {
    this.store.dispatch(loadAiPanel());
  }

  isOnEmailsCreatePage(): boolean {
    return this.router.url.includes('/emails/create');
  }

  constructor(private store: Store, private router: Router) {}
}
